import { SelectedObject } from "@/components/selection-sidebar/types";
import {
  UnitsContainer,
  UnitsContainerProps,
} from "@/components/ui-v2/Units/UnitsContainer";

import { useExportInferencePricing } from "../hooks/useExportInferencePricing";

type ExportFormUnitsContainerProps = Partial<UnitsContainerProps> & {
  removeBackground?: boolean;
  objects: SelectedObject[];
};

export const ExportFormUnitsContainer = (
  props: ExportFormUnitsContainerProps,
) => {
  const { removeBackground, objects } = props;
  const { actionPricing, isFetching } = useExportInferencePricing({
    removeBackground,
    batchSize: objects.length,
  });
  const units = actionPricing?.actionPrice;
  const isGated = !!actionPricing?.isGated;

  return (
    <UnitsContainer
      isLoading={isFetching}
      isGated={isGated}
      units={units}
      {...props}
    />
  );
};
